import React, { useState, useCallback } from 'react';

import Moment from 'moment-timezone';

import { HeaderSeparator, ReportDatePicker, ReportHeader, ReportHeaderDates, ReportHeaderDesktopActions, ReportHeaderMobileActions, ReportMenuConfigure, ReportMobileMenu, RunButton } from '@/components/reports/header'

export default function OptoutHeader({ children, onChange, dates, isLoading, sync, title }) {
  const [startDate, setStartDate] = useState(Moment(dates.startDate))
  const [endDate, setEndDate] = useState(Moment(dates.endDate))

  const handleChangeDates = useCallback(({ startDate, endDate }) => {
    setStartDate(startDate)
    setEndDate(endDate)
    if (startDate && endDate) {
      onChange({ startDate, endDate })
    }
  })

  return <>
    <ReportHeader title={`${title} Report`}>
      <ReportHeaderDates>
        <ReportDatePicker dates={{ startDate, endDate }} onChange={handleChangeDates} />
      </ReportHeaderDates>
      <HeaderSeparator />
      <ReportHeaderDesktopActions>
        {children}
      </ReportHeaderDesktopActions>
      <ReportHeaderMobileActions>
        <ReportMobileMenu>
          <ReportMenuConfigure />
        </ReportMobileMenu>
        <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
      </ReportHeaderMobileActions>
    </ReportHeader>
  </>
}
